// 启用禁用枚举 1.启用、2.禁用
export enum EnableDisableEnu {
  ENABLE = 1,
  DISABLE = 2,
}
export enum EnableDisableEnuName {
  ENABLE = '启用',
  DISABLE = '禁用',
}

// 来源（1.内部、2.外部）
export enum SourceEnu {
  INTERNAL = 1,
  EXTERNAL = 2,
}
export enum SourceEnuName {
  INTERNAL = '内部',
  EXTERNAL = '外部',
}

// 归属（1.线上、2.线下）
export enum OnlineOfflineEnu {
  ONLINE = 1,
  OFFLINE = 2,
}
export enum OnlineOfflineEnuName {
  ONLINE = '线上',
  OFFLINE = '线下',
}

// 对接方式（0.直连、1.吉客云）
export enum ConnectionTypeEnu {
  DIRECT = 0,
  JIKE_CLOUD = 1,
}

export enum ConnectionTypeEnuName {
  DIRECT = '直连',
  JIKE_CLOUD = '吉客云',
}

//渠道类型（1.三方渠道、2.外卖渠道、3.自建渠道、4.门店渠道、5.其他渠道）
export enum ChannelTypeEnu {
  THREE_PARTIES = 1,
  TAKEOUT = 2,
  SELF_BUILD = 3,
  STORE = 4,
  OTHER = 5,
}
export enum ChannelTypeEnuName {
  THREE_PARTIES = "三方渠道",
  TAKEOUT = "外卖渠道",
  SELF_BUILD = "自建渠道",
  STORE = "门店渠道",
  OTHER = "其他渠道",
}

//发货类型(1.自发、2.省店代发)
export enum OutTypeEnu {
  SELF = 1,
  PROVINCE_STORE = 2,
}
export enum OutTypeEnuName {
  SELF = '自发',
  PROVINCE_STORE = '省店代发',
}

// 是否支持手动开单（0未支持、1.已支持）
export enum DoesItSupportEnu {
  NO = 0,
  YES = 1,
}
export enum DoesItSupportEnuName {
  NO = '未支持',
  YES = '已支持',
}

//贸易类型(1.一般贸易、2.保税跨境)
export enum TradeTypeEnu {
  GENERAL = 1,
  BONDED = 2,
}
export enum TradeTypeEnuName {
  GENERAL = '一般贸易',
  BONDED = '保税跨境',
}

//店铺经营类型（1一般贸易、2.自营、3.加盟（连锁））
export enum StoreBusinessTypeEnu {
  // GENERAL = 1,
  SELF = 2,
  JOINED = 3,
}
export enum StoreBusinessTypeEnuName {
  // GENERAL = '一般贸易',
  SELF = '自营',
  JOINED = '加盟（连锁）',
}

//库存扣减方式（1.下单减库存,2.付款减库存）
export enum StockDeductionTypeEnu {
  ORDER = 1,
  PAYMENT = 2,
}
export enum StockDeductionTypeEnuName {
  ORDER = '下单减库存',
  PAYMENT = '付款减库存',
}

//发布时商品默认在店状态（1.仓库中（已下架）,2.已上架）
export enum CommodityStatusEnu {
  STOCK = 1,
  UP = 2,
}
export enum CommodityStatusEnuName {
  STOCK = '仓库中（已下架）',
  UP = '已上架',
}

//抓单/库存同步 频率（1.按时间点、2.按时间间隔）
export enum SynchronizationFrequencyEnu {
  TIME = 1,
  INTERVAL = 2,
}
export enum SynchronizationFrequencyEnuName {
  TIME = '按时间点',
  INTERVAL = '按时间间隔',
}

//是否有店铺仓（1.是,2.否）
export enum YesNo {
  YES = 1,
  NO = 2,
}
export enum YesNoName {
  YES = '是',
  NO = '否',
}